// React Imports
import React, {useEffect, useRef, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from "@mui/material/Box";
import { InputLabel, Select, Stack} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

// App Imports
import {changeWorkQueue} from "../workQueueSlice";
import {changeWork} from "../../Work/workSlice";
import {getProductContractHierarchy} from "../../Contract/ContractClient";
import RefreshIcon from "@mui/icons-material/Refresh";



// main function
export default function ContractHierarchySearchBar() {

    const {register, handleSubmit} = useForm();
    const [productDropdown, setProductDropdown] = useState([]);
    const [contractHierarchyDropdown, setContractHierarchyDropdown] = useState([]);
    const [contractHierarchyValue, setContractHierarchyValue] = useState([]);

    const selectorTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.mousedContractId);
    const selectorTitle = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitle);
    const selectorMultiSingle = useSelector((state) => state.workQueueSlc.value.propertyDropdownMultiSingle);

    const [guildDropdown, setGuildDropdown] = useState([]);
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [productValue, setProductValue] = useState([useSelector((state) => state.obligationHierarchySlc.value.myProductId)]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [selectedTopLevelProduct, setSelectedTopLevelProduct] = useState([]);
    const [selectedContractHierarchy, setSelectedContractHierarchy] = useState([]);
    // const [selectedProduct, setSelectedProduct] = useState([]);
    const dispatchData = useDispatch();

    const handleClearClick = () => {
        setProductValue("");
        setGuildValue("");
        setR2mValue("");
    };


    const handleClearContractHierarchyClick = () => {
        setProductValue("");
        dispatchData(changeWorkQueue({
            selectedContractId: 0,
            selectedContractName: null,
            selectedContractLevel: null,
            selectedContractProductId: null,
            selectedContractType: null,
            selectedContractGuild: null,
            selectedContractFailedExpressionCount: null,
            selectedContractFailedFilterCount: null,
            selectedContractInputMissingCount: null,
            selectedContractPropertyId: null,
            selectedContractStatus: null,
            selectedContractDescription: null,
             bigAddButtonDisplay: true
        }));
        dispatchData(changeWork({
            propertyId: null}));
    };


    const handleClearR2mClick = () => {
        setR2mValue("");
    };

    const fetchContractHierarchy = () => {
        // getSampleContracts()
        // if (selectorProductId > 0){
        if (selectorTitleId > 0){
            // console.log(" selectorTitleId ", selectorTitleId);
            // console.log(" selectorMultiSingle ", selectorMultiSingle);
            // getProductContractHierarchy(selectorProductId)
            getProductContractHierarchy(selectorTitleId, selectorMultiSingle)
            // getProductContractHierarchy(101401001, 'multi')
                // getProductContracts(selectorProductId)
                // getQueueC()

                .then(data => {
                    console.log('My contract hierarchy data');
                        console.log(data);
                    setContractHierarchyDropdown(data.filter(data => data.contractId > 0));
                    console.log('My dropdown data');
                    console.log(data.filter(data => data.contractId > 0));
                     }
                );}};


    useEffect(() => {
        console.log("product contracts fetch triggered by grid refresh = true");
        fetchContractHierarchy();
        dispatchData(changeWorkQueue({workQueueCGridRefresh: false}));
    }, [useSelector((state) => state.workQueueSlc.value.workQueueCGridRefresh)===true]);


    useEffect(() => {
        console.log("This is for the product dropdown...");
        fetchContractHierarchy();
    }, []);



    const handleContractHierarchyChange = (prod2) => {
        // setSelectedProduct(dropdownProducts.target.seriesId);
        console.log("The contract hierarchy has changed");
        console.log("This is for the selected contract hierarchy menu change");
        console.log(prod2);
        console.log("selectedContractHierarchy");
        console.log(contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2));
        // console.log(contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.id === parseInt(prod)).expansionDepth);
        // dispatchData(changeWork({propertyId: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).id,
        //     expansionDepth: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).expansionDepth}));
        setSelectedContractHierarchy(contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.id === prod2));
        console.log(contractHierarchyDropdown[0]);
        dispatchData(changeWorkQueue({workQueueCGridRefresh: true, cardsState: true, bigAddButtonDisplay: false,
            selectedContractId: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).contractId,
            selectedContractName: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).name,
            selectedContractLevel: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).contractLevel,
            selectedContractProductId: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).propertyId,
            selectedContractType: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).contractType,
            selectedContractGuild: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).guild,
            selectedContractFailedExpressionCount: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).failedExpressionCount,
            selectedContractFailedFilterCount: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).failedFilterCount,
            selectedContractInputMissingCount: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).inputMissingCount,
            selectedContractPropertyId: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).propertyId,
            selectedContractStatus: contractHierarchyDropdown.find(contractHierarchyDropdown => contractHierarchyDropdown.contractId === prod2).status,
            selectedContractSectionId: 0
        }));


    };



    function onSubmit(data) {
        console.log("here's my obligation/payment/fringe search data before I submit it ")
        console.log({data})
        setSelectedProduct(productDropdown.filter(productDropdown => productDropdown.productId = data.my_product_id));
        console.log("selectedProduct");
        // console.log(productDropdown.filter(productDropdown => productDropdown.productId  === 1001));
        console.log(productDropdown.filter(productDropdown => productDropdown.productId === data.my_product_id));
        // dispatchData(changeWork({propertyId: data.my_product_id, propertyLevel: productDropdown.filter(productDropdown => productDropdown.productId = data.myProductId)});
        dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
        // dispatchData(changeBulkEditControls({ bulkEditGridRefresh: true}));
        // dispatchData(changeWork({
        //             propertyId: data.my_product_id
        //
        //         }));
    };

    const handleBackButton = () => {
        dispatchData(changeWorkQueue({cardsState: false}));
    };

    const searchForm  = () => (
        <form

            onSubmit={handleSubmit((data)=>onSubmit(data))}
        >
            <Box
                sx={{ width: 800 , height: 60, pl: 1}}
                role="presentation"
            >


                <Stack direction={"row"} spacing={2}>
                    {/*<h2> Search</h2>*/}
                    <Button onClick={() => handleBackButton()} >BACK</Button>
                    <Box >
                        {/*<FormControl variant="standard" sx={{ m: 1, minWidth: 600 }}>*/}
                        {/*    <InputLabel htmlFor="contractContractHierarchy.id"  onClick={handleClearContractHierarchyClick}>Contract</InputLabel>*/}
                        {/*    <Select*/}
                        {/*        {...register('my_contract_hierarchy_id', { required: true })}*/}
                        {/*        isClearable={true}*/}
                        {/*        id="my_contract_hierarchy_id"*/}
                        {/*        onChange={(newContractHierarchyValue) => {*/}
                        {/*            setContractHierarchyValue(newContractHierarchyValue.target.value);*/}
                        {/*            console.log(newContractHierarchyValue.target.value);*/}
                        {/*            handleContractHierarchyChange(newContractHierarchyValue.target.value);*/}
                        {/*        }}*/}
                        {/*        // type= "submit"*/}
                        {/*        defaultValue=  {contractHierarchyValue}*/}
                        {/*        value = {contractHierarchyValue}*/}
                        {/*    >*/}
                        {/*        {contractHierarchyDropdown.map((productItem) =>*/}
                        {/*            <MenuItem value={productItem.contractId}>{productItem.hierarchyNew}</MenuItem>*/}
                        {/*        )}*/}
                        {/*    </Select>*/}
                        {/*</FormControl>*/}

                        <FormControl variant="standard" sx={{ m: 1, minWidth: 600 }}>
                            <InputLabel htmlFor="contractContractHierarchy.id"  onClick={handleClearContractHierarchyClick}>Contract</InputLabel>
                            <Select
                                {...register('my_contract_hierarchy_id', { required: false })}
                                isClearable={true}
                                id="my_contract_hierarchy_id"
                                onChange={(newContractHierarchyValue) => {
                                    setContractHierarchyValue(newContractHierarchyValue.target.value);
                                    console.log(newContractHierarchyValue.target.value);
                                    handleContractHierarchyChange(newContractHierarchyValue.target.value);
                                }}
                                // type= "submit"
                                defaultValue=  {selectorContractId}
                                // value = {contractHierarchyValue}
                            >
                                {contractHierarchyDropdown.map((productItem) =>
                                    <MenuItem value={productItem.contractId}
                                    >{productItem.seasonName} {productItem.propertyId} {productItem.propertyTitle} {productItem.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Box>

                    {/*<Button*/}
                    {/*    type= "submit"*/}
                    {/*>Retrieve</Button>*/}

                </Stack>
            </Box>

        </form>
    );

    return (
        <div>
            {searchForm()}
        </div>

    )


}

